
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.55725 0H16.3265C17.097 0 17.9318 0.625611 17.996 1.37634V18.7058C17.996 19.3314 17.4823 19.8319 16.9686 19.957C16.4549 20.0821 15.6843 19.8319 15.1706 19.4565L13.7579 18.0802L12.6021 19.5816C11.9599 20.0821 10.9325 20.0821 10.4188 19.5816L9.00608 18.0802L7.7218 19.4565C7.46494 19.8319 7.07966 19.957 6.69437 19.957C6.3895 19.957 6.16505 19.8003 5.89374 19.6109C5.82218 19.561 5.74736 19.5087 5.66695 19.4565L4.38267 18.0802L2.84153 19.4565C2.19939 19.957 1.94253 19.957 1.42882 19.957C0.91511 19.957 0.0161133 19.5816 0.0161133 18.5806V1.50147C0.0161133 0.625611 0.786682 0 1.55725 0Z"
    fill="currentColor"
  ></path>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.51954 5.5H8.62344C8.93513 5.5 9.14292 5.2 9.14292 4.75C9.14292 4.3 8.93513 4 8.62344 4H4.51954C4.20785 4 4.00006 4.3 4.00006 4.75C4.00006 5.2 4.20785 5.5 4.51954 5.5ZM12.3774 7H4.5661C4.22648 7 4.00006 7.3 4.00006 7.75C4.00006 8.2 4.22648 8.5 4.5661 8.5H12.434C12.7736 8.5 13.0001 8.2 13.0001 7.75C12.9435 7.3 12.717 7 12.3774 7ZM4.51954 11.5H8.62344C8.93513 11.5 9.14292 11.8 9.14292 12.25C9.14292 12.7 8.93513 13 8.62344 13H4.51954C4.20785 13 4.00006 12.7 4.00006 12.25C4.00006 11.8 4.20785 11.5 4.51954 11.5Z"
    fill="white"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Invoice',
    }) as DefineComponent
    </script>
    